import React, { Component } from "react";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QuotationUpload from "../../../QuotationUpload/QuotationUpload";

class AssetUploadTemplate extends Component {
  state = {};

  _resetFileDetails = () => {
    this.props.setErrMsg("");
    this.props.setDocUri(null);
  };

  _uploadDocument = () => {
    const { selectedCategoryID, docURI } = this.state;
    if (selectedCategoryID !== null) {
      return (
        <QuotationUpload
          uploaded={docURI !== null}
          setDoc={this.props.setDoc}
          resetFileDetails={this._resetFileDetails}
          page="DOCUMENT"
        />
      );
    }
    return null;
  };

  render() {
    return (
      <div className="select-template-list-wrapper">
        {this._uploadDocument()}
      </div>
    );
  }
}

export default AssetUploadTemplate;
